module.exports = __webpack_public_path__ + "static/media/Frame (6).4b8ac484.png";